import { useState, useEffect } from "react"
import { useNavigate, useLocation } from "react-router"
import { toast } from "react-toastify"
import Server from "../../Shared/Server"
import Spinner from "../../Shared/Spinner"
import {InputField} from "../../Shared/InputField"

const UpdateBookVouchersForm = () => {
  const [errors, setErrors] = useState({})
  const [isLoading, setIsLoading] = useState(false)

  const [formData, setFormData] = useState({
      book: "",
      prev_book: "",

    //   I wanna use year & month to redirect new book's vouchers
      year: "",
      month: "",
  })
  const {book, prev_book, year, month} = formData

  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {

    if (location.state){
        const {payload} = location.state
        setFormData({
            prev_book: payload.book,
            year: payload.year,
            month: payload.month,
            book: payload.book
        })
    }

  }, [location]);
  

  const onChange = (e) => {
      setFormData((prevState) => ({
          ...prevState,
          [e.target.name]: e.target.value
      }))
  }

  const onSubmit = (e) => {
      e.preventDefault()
      
      updateVoucher({book, prev_book})
  }
  
  // update voucher
  const updateVoucher = async (payload) => {
      setIsLoading(true)
      try {
          const response = await Server.put(`/vouchers/book/${payload.prev_book}`, {book: payload.book});
          setIsLoading(false)
          toast.success(response.data.detail);
          navigate(`/monthly-voucher-detail`, { state: {payload: {
            year: year,
            month: month,
            book: payload.book
          }}})
      } catch (error) {
          setIsLoading(false)
          if(error.response.status === 401){
              navigate('/login')
          }else if (error.response.status === 422){
            setErrors({})
            error.response?.data?.detail.map((err) => (
                setErrors((prevState) => ({
                    ...prevState,
                    [err.loc[1]]: err.msg
                }))
            ))
        }else if (error.response.status === 403){
              toast.error(error.response.data.detail);
              navigate('/');
          }else {
            toast.error(error.response.data.detail);
        }
      }
  }

  if(isLoading){
      return <Spinner/>
  }


return (
  <>
    <div className="card">
            <div className="card-header p-2 bg-info text-white d-flex justify-content-center">
                <h3 className="card-title">Update Book Vouchers Form</h3>
            </div>
            <div className="card-body">
                <form onSubmit={onSubmit}>
                    <div className="row">
                        <div className="col-md-12">
                            <InputField
                                name="book"
                                type="text"
                                label="New Book"
                                value={book}
                                onChange={onChange}
                                error={errors.book}
                            />
                        </div>
                    </div>
                    <br/>
                    <div className="row">
                        <div className="col-md-12">
                            <input type="submit" className="btn btn-outline-info" value="Update Book" style={{float: 'right'}}/>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <br/>
  </>
)
}

export default UpdateBookVouchersForm
